import { createSlice } from "@reduxjs/toolkit";
import { PAGELENGTH } from "components/common/ListLayout";
import Api from "services/api";

export const initialState = {
  timesheets: [],
  error: null,
  loader: false,
  total: 0,
  is_more: false,
  last_page: 1,
  current_page: 1,
  per_page: PAGELENGTH,
};

export const clientTimesheetSlice = createSlice({
  name: "clientTimesheet",
  initialState,
  reducers: {
    setTimesheets: (state, { payload }) => {
      state.timesheets = payload?.data ?? [];
      state.total = payload?.total ?? 0;
      state.is_more = payload?.is_more ?? false;
      state.last_page = payload?.last_page ?? 1;
      state.current_page = payload?.current_page ?? 1;
      state.per_page = payload?.per_page ?? PAGELENGTH;
    },
    setMoreTimesheets: (state, { payload }) => {
      state.timesheets = state.timesheets.concat(payload.data);
      state.total = payload.total;
      state.is_more = payload.is_more;
      state.last_page = payload?.last_page;
      state.current_page = payload?.current_page;
      state.per_page = payload?.per_page;
    },
    clearAllTimesheets: (state) => {
      state.timesheets = [];
      state.error = null;
      state.loader = false;
    },
    setLoader: (state, { payload }) => {
      state.loader = payload;
    },
    setError: (state, { payload }) => {
      state.error = payload;
    },
  },
});

// ✅ Fetch client Timesheets
export const fetchClientTimesheets =
  (page = 1, params = {}, disableLoader = false, Async = false) =>
  async (dispatch) => {
    if (!disableLoader) dispatch(setLoader(true));
    try {
      const result = await Api.fetchClientTimesheets(page, params);

      if (result.status >= 200 && result.status < 300) {
        const response = result.data;

        if (Async) return response;

        dispatch(
          setTimesheets({
            data: response.data,
            total: response.pagination?.total,
            is_more:
              response.pagination?.current_page < response.pagination?.last_page,
            last_page: response.pagination?.last_page,
            current_page: response.pagination?.current_page,
            per_page: response.pagination?.per_page,
          })
        );
      } else if (result.status === 422) {
        if (Async) return [];
        dispatch(setError(result.data));
      }
    } catch (error) {
      console.error("fetchClientTimesheets error:", error);
      dispatch(setError(error));
    } finally {
      if (!disableLoader) dispatch(setLoader(false));
    }
  };

export const {
  setTimesheets,
  setMoreTimesheets,
  clearAllTimesheets,
  setLoader,
  setError,
} = clientTimesheetSlice.actions;

export default clientTimesheetSlice.reducer;

// ✅ Selector
export const clientTimesheetSelector = (state) => state.clientTimesheet;
